import { useQuery } from "@tanstack/react-query";

import { getMonitor, type FreshnessMeta } from "./api";
import { FilesTab } from "./FilesTab";
import { HistoryTab } from "./HistoryTab";
import { MonitorTab } from "./MonitorTab";
import { RatesTab } from "./RatesTab";
import { TplHistoryTab } from "./TplHistoryTab";
import { FulfilmentIndexBoundary } from "./fulfilment_index/FulfilmentIndexBoundary";
import { FulfilmentIndexTab } from "./fulfilment_index/FulfilmentIndexTab";

export function useFulfilmentCostsMeta(enabled: boolean): FreshnessMeta | null | undefined {
  const head = useQuery({
    queryKey: ["pfc", "monitor", { country: "ALL", page: 1, sort: "age", direction: "asc" }],
    queryFn: () => getMonitor({ country: "ALL", page: 1, sort: "age", direction: "asc" }),
    enabled,
    retry: 1,
  });
  return enabled ? head.data?.meta : undefined;
}

export function FulfilmentCostsModule({ activeTabKey, areaName }: { decision: "edit" | "view" | "none"; activeTabKey: string | null; areaName: string; ownerName?: string | null }) {
  if (!activeTabKey || activeTabKey === "fulfilment_index") return <FulfilmentIndexBoundary><FulfilmentIndexTab areaName={areaName} /></FulfilmentIndexBoundary>;
  if (activeTabKey === "rates") return <RatesTab areaName={areaName} />;
  if (activeTabKey === "files") return <FilesTab areaName={areaName} />;
  if (activeTabKey === "history") return <HistoryTab areaName={areaName} />;
  if (activeTabKey === "tpl_history") return <TplHistoryTab areaName={areaName} />;
  return <MonitorTab areaName={areaName} />;
}
